import React from "react";
import point from "./../../../../Images/point.png";

const NailExtensionInSahakaraExpertise = () => {
  return (
    <div className="hairSalonInSahakaraWhy">
      <h5>SCENT Salon’s Expertise in Nail Extensions</h5>
      <p>
        When you choose SCENT for nail extensions near Sahakara Nagar, you're
        not just getting a service—you’re indulging in an experience. Our nail
        specialists take the time to understand your style preferences and
        advise you on the type of extension that suits you best. Each extension
        type has its unique qualities, and our team helps you choose the one
        that will complement your lifestyle and personal aesthetic.
      </p>
      <ul>
        <li>
          <span>
            <img src={point} alt="point" />
            Acrylic Nail Extensions{" "}
          </span>
          <p>
            Acrylic extensions are ideal if you’re looking for durability. These
            extensions are crafted from a mixture of powder and liquid, forming
            a hard protective layer. They’re perfect for a more dramatic look
            and are easily customizable.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Gel Nail Extensions{" "}
          </span>
          <p>
            For those who prefer a natural look, gel extensions are a fantastic
            choice. They give a glossy, natural finish and feel lighter on your
            nails. Our gel nail extensions near Sahakara Nagar are especially
            popular for their durability and natural appearance.
          </p>
        </li>
        <li>
          <span>
            <img src={point} alt="point" />
            Silk Nail Wraps{" "}
          </span>
          <p>
            These are a less common but elegant option for those seeking a more
            delicate approach to nail extensions. Silk wraps are ideal for
            reinforcing weak nails and providing a smooth, natural finish.
          </p>
        </li>
      </ul>
    </div>
  );
};

export default NailExtensionInSahakaraExpertise;
